import type { Concept } from '../utils/channels';

export function conceptHasEcomId(concept: Concept) {
  return concept === 'stadium';
}
